"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const ExtrusionObjectsBase_3d_1 = __importDefault(require("../classes/ExtrusionObjectsBase.3d"));
class Extrusion extends ExtrusionObjectsBase_3d_1.default {
    constructor() {
        super();
        this.type = 'Extrusion';
    }
}
exports.default = Extrusion;
